import { fork, take, call, put, all } from "redux-saga/effects";

import {
  getVideoCourseCategoriesResponse,
  getVideoCoursesListingResponse,
  getVideoDetailListingResponse,
  // getBrokerVideoListingResponse,
  getVideoComptResponse,
  getBrokerVideoDetailResponse,
  getMyVideosResponse,
  getVideoCoursesListingByCatResponse,
  getVideoCoursesListingBySubCatResponse,
  getVideoCoursesListingRelatedResponse,
  getVideoListCatDataRes,
  getPopularVideosResponse,
  getUsefulVideosResponse,
  getFreeVideosResponse,
  getGlobalSearchVideosResponse,
  getUpcomingVideosResponse,
} from "./actions";
import types from "./types";
import {
  apiDirect,
  getAPI,
  postAPI,
  postAPIWithoutModule,
} from "../../api/generic";

export function* doGetVideoCourseCategories() {
  while (true) {
    const { payload } = yield take(types.VIDEO_COURSE_CATEGORIES);
    const response = yield call(getAPI, payload);
    yield put(getVideoCourseCategoriesResponse(response));
  }
}

// export function* doGetVideoCoursesListing() {
//   while (true) {
//     const { payload } = yield take(types.VIDEO_COURSES_LISTING)
//     const response = yield call(postAPI, payload)
//     yield put(getVideoCoursesListingResponse(response))
//   }
// }

// export function* doGetVideoDetailListing() {
//   while (true) {
//     const { payload } = yield take(types.VIDEO_DETAIL_LISTING)
//     const response = yield call(postAPIWithoutModule, payload)
//     yield put(getVideoDetailListingResponse(response))
//   }
// }

// export function* doGetBrokerVideoDetailList() {
//   while (true) {
//     const { payload } = yield take(types.VIDEO_DETAIL_BROKER_ADMIN)
//     const response = yield call(postAPI, payload)
//     yield put(getBrokerVideoListingResponse(response))
//   }
// }

// video listing page
export function* doGetVideoCoursesListing() {
  while (true) {
    const { payload } = yield take(types.VIDEO_COURSES_LISTING);
    const response = yield all([
      call(postAPI, payload.ecom),
      call(postAPI, payload.broker),
    ]);
    yield put(getVideoCoursesListingResponse(response));
  }
}

// video view page
export function* doGetVideoCourseListingByCat() {
  while (true) {
    const { payload } = yield take(types.VIDEO_COURSES_LISTING_BY_CAT);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getVideoCoursesListingByCatResponse(response));
  }
}

// video view page
export function* doGetVideoCourseListingBySubCat() {
  while (true) {
    const { payload } = yield take(types.VIDEO_COURSES_LISTING_BY_SUB_CAT);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getVideoCoursesListingBySubCatResponse(response));
  }
}

// video view page
export function* doGetVideoCourseListingRelated() {
  while (true) {
    const { payload } = yield take(types.VIDEO_COURSES_LISTING_RELATED);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getVideoCoursesListingRelatedResponse(response));
  }
}

// video view page
export function* doGetVideoDetailFromEcom() {
  while (true) {
    const { payload } = yield take(types.VIDEO_DETAIL_LISTING);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getVideoDetailListingResponse(response));
  }
}
export function* doGetVideoDetailFromBroker() {
  while (true) {
    const { payload } = yield take(types.VIDEO_INFO_BROKER_ADMIN);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getBrokerVideoDetailResponse(response));
  }
}

export function* doGetVideoCompletion() {
  while (true) {
    const { payload } = yield take(types.VIDEO_COMPLETION_TRACK);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getVideoComptResponse(response));
  }
}

export function* doGetMyVideos() {
  while (true) {
    const { payload } = yield take(types.MY_VIDEO_FETCH);
    // const response = yield all([
    //   call(postAPIWithoutModule, payload.ecom),
    //   call(postAPIWithoutModule, payload.broker)
    // ])
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getMyVideosResponse(response));
  }
}

export function* doGetVideoListCatData() {
  while (true) {
    const { payload } = yield take(types.GET_VIDEO_LISTING_CAT_DATA);
    const response = yield call(apiDirect, payload);
    yield put(getVideoListCatDataRes(response));
  }
}

export function* doGetPopularVideosData() {
  while (true) {
    const { payload } = yield take(types.POPULAR_VIDEOS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getPopularVideosResponse(response));
  }
}

export function* doGetUsefulVideosData() {
  while (true) {
    const { payload } = yield take(types.USEFUL_VIDEOS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getUsefulVideosResponse(response));
  }
}

export function* doGetFreeVideosData() {
  while (true) {
    const { payload } = yield take(types.FREE_VIDEOS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getFreeVideosResponse(response));
  }
}

export function* doGetGlobalSearchVideos() {
  while (true) {
    const { payload } = yield take(types.GLOBAL_SEARCH_VIDEOS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getGlobalSearchVideosResponse(response));
  }
}

export function* doGetUpcomingVideos() {
  while (true) {
    const { payload } = yield take(types.GET_UPCOMING_VIDEOS);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getUpcomingVideosResponse(response));
  }
}

function* video() {
  yield fork(doGetVideoCourseCategories);
  yield fork(doGetVideoCoursesListing);
  yield fork(doGetVideoCompletion);
  yield fork(doGetVideoDetailFromEcom);
  yield fork(doGetVideoDetailFromBroker);
  yield fork(doGetMyVideos);
  yield fork(doGetVideoCourseListingByCat);
  yield fork(doGetVideoCourseListingBySubCat);
  yield fork(doGetVideoCourseListingRelated);
  yield fork(doGetVideoListCatData);
  yield fork(doGetPopularVideosData);
  yield fork(doGetUsefulVideosData);
  yield fork(doGetFreeVideosData);
  yield fork(doGetGlobalSearchVideos);
  yield fork(doGetUpcomingVideos);
}

export default video;
